import {clearFeedbacksByName, clearInputsByName, getInputsByName} from "../../helpers/forms";
import {initProjectAssignmentSelect} from "../../common/projects/select";
import {initContractorTagsSelect} from "../../common/contractors/tagsSelect";
import {setupFileUploader} from "../../common/filesUploader";
import {autoHeightTextArea} from "../../helpers/inputs/autoHeightTextArea/autoHeightTextArea";

/**
 * Initializes a form to create/update a contractor
 *
 * @param {Element }formElement
 */
function initContractorForm(formElement) {

	// Setup project select
	const projectsSelect = initProjectAssignmentSelect(formElement.querySelector('.project-assignment-select-component'));

	// Setup tag select
	const contractorTagsSelect = initContractorTagsSelect(formElement.querySelector('.contractor-tags'))

	// Setup templates
	const phoneTemplate = formElement.querySelector('.templates .phone-input-template');

	// Setup events handlers
	formElement.querySelector('.add-phone-button')
		.addEventListener('click', () => addPhoneInput())

	// Subsection checkboxes
	formElement.querySelectorAll('input[name="has_insurance"],input[name="has_tax_information"]')
		.forEach(checkbox => {
			checkbox.addEventListener('click', renderSubsections);
		})

	// Setup existing phones
	const existingPhonesInput = formElement.querySelector('input[name="existing_phones"]');
	if (existingPhonesInput) {
		try {
			const existingPhones = JSON.parse(existingPhonesInput.value);
			if (existingPhones) {
				existingPhones.forEach((phone, index) => {
					if (index === 0) {
						// Skip first one as that one is handled by the server side
						return;
					}
					addPhoneInput(phone);
				})
			}
		} catch (e) {
			// If input is empty or malformed ignore it
		}
	}

	// Setup file uploads
	const filesUploadUrl = formElement.querySelector('input[name="file_uploads_url"]').value;

	const insuranceFiles = JSON.parse(formElement.querySelector('input[name="insurance_files"]').value);

	const insuranceFileUploader = setupFileUploader(
		{
			target: formElement.querySelector('.insurance_files'),
		},
		filesUploadUrl,
		insuranceFiles
	)

	const taxFiles = JSON.parse(formElement.querySelector('input[name="tax_files"]').value);

	const taxFileUploader = setupFileUploader(
		{
			target: formElement.querySelector('.tax_files'),
		},
		filesUploadUrl,
		taxFiles
	)

	// Fit contractor notes to its content
	autoHeightTextArea(formElement.querySelector('textarea[name="contractor_notes"]'));

	// First render
	renderSubsections();

	return {
		formElement,
		fields: [
			"first_name",
			"last_name",
			"email",
			"company_name",
			"address",
			"city",
			"state",
			"zip",
			// Insurance info
			"insurance_name",
			"insurance_policy_number",
			// Tax info
			"contractor_ssn",
			"contractor_tax_id",
			// Notes
			'contractor_notes'
		],
		getValues() {
			const values = getInputsByName(formElement, this.fields);

			// Get projects
			values.projects = projectsSelect.select2('data').map(option => option.id);

			// Get tags
			values.tags = contractorTagsSelect.select2('data').map(option => option.id);

			// Get files
			values.insurance_files = insuranceFileUploader.getFilesForSubmission();
			values.tax_files = taxFileUploader.getFilesForSubmission();

			// Get phones
			values.phones = Array.from(
				formElement.querySelectorAll('input[name="phones[]"]')
			).map(element => element.value);

			return values;
		},
		clearFeedbacks() {
			return clearFeedbacksByName(formElement);
		},
		clearInputs() {
			clearInputsByName(formElement, this.fields)

			// Clear file uploads
			insuranceFileUploader.cancelAll();
			taxFileUploader.cancelAll();
		},
		selectProject(projectId) {
			const projectSelectElement = projectsSelect[0];
			const option = projectSelectElement.querySelector(`option[value="${projectId}"]`);
			if (option) {
				// Clear current selection
				$(projectSelectElement).val(null);

				option.selected = true;
				projectsSelect.trigger('change');
			}
		}
	}

	// Methods

	/**
	 * Hides or displays subsections
	 */
	function renderSubsections() {
		const subsections = [
			{
				checkbox: 'input[name="has_insurance"]',
				container: '.insurance-data-container'
			},
			{
				checkbox: 'input[name="has_tax_information"]',
				container: '.contractors-tax-container'
			},
		]

		subsections.forEach(section => {
			const container = formElement.querySelector(section.container);
			if (formElement.querySelector(section.checkbox).checked) {
				container.classList.remove('d-none')
			} else {
				container.classList.add('d-none');
			}
		})
	}

	function addPhoneInput(phone = null) {
		const newInputContainer = phoneTemplate.cloneNode(true);
		newInputContainer.classList.remove('phone-input-template');

		newInputContainer.querySelector('.remove-phone-button')
			.addEventListener('click', () => removePhoneInput(newInputContainer))

		// Add phone input name because the template HTML does not have it
		newInputContainer.querySelector('.phone-input').name = 'phones[]';

		if (phone) {
			// Pre seed phone input
			newInputContainer.querySelector('input').value = phone;
		}

		formElement.querySelector('.phones-container').appendChild(newInputContainer);
	}

	function removePhoneInput(inputContainer) {
		inputContainer.parentElement.removeChild(inputContainer);
	}
}

export {initContractorForm}
